import _regeneratorRuntime from "babel-runtime/regenerator";

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import GraphicAsset from "./GraphicAsset";
import Filters from "./Filters";
import { consumeContext } from "../../EditorContext";
import Slider from "react-slick";

var Assets = function (_React$Component) {
  _inherits(Assets, _React$Component);

  function Assets() {
    var _temp, _this, _ret;

    _classCallCheck(this, Assets);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onBeginAssetDrag = function () {
      _this.props.EditorContext.pauseVideo();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Assets.prototype.componentDidMount = function componentDidMount() {
    var _props$EditorContext$ = this.props.EditorContext.state.assets.assets,
        assets = _props$EditorContext$ === undefined ? [] : _props$EditorContext$;

    if (assets.length === 0) {
      this.props.EditorContext.assets.loadAssets();
    }
  };

  Assets.prototype.renderAssets = function renderAssets() {
    var _this2 = this;

    var assets = this.props.EditorContext.state.assets;
    var assetsList = assets.assets || [];
    var settings = {
      dots: false,
      infinite: false,
      touchMove: false,
      className: "center",
      speed: 500,
      slidesToShow: 14,
      slidesToScroll: 14,
      initialSlide: 0,
      beforeChange: function beforeChange(oldIndex, newIndex) {
        if (newIndex < oldIndex) {
          return;
        }

        if (assetsList.length <= newIndex + 14) {
          _this2.props.EditorContext.assets.loadMoreAssets();
        }
      },
      responsive: [{
        breakpoint: 1600,
        settings: {
          slidesToShow: 10,
          slidesToScroll: 10
        }
      }, {
        breakpoint: 1366,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 8
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6
        }
      }]
    };
    return React.createElement(Slider, settings, assetsList.map(function (asset) {
      return React.createElement(GraphicAsset, {
        key: asset.url,
        asset: asset,
        onBeginDrag: _this2.onBeginAssetDrag,
        onDelete: _this2.onDeleteAsset
      });
    }), assetsList.length === 0 && React.createElement("div", {
      className: "recorder__gallery-item"
    }));
  };

  Assets.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(Filters, null), " ", this.renderAssets());
  };

  _createClass(Assets, [{
    key: "onDeleteAsset",
    get: function get() {
      var _this3 = this;

      var _props$EditorContext = this.props.EditorContext,
          applyFilter = _props$EditorContext.assets.applyFilter,
          _props$EditorContext$2 = _props$EditorContext.state.assets,
          _props$EditorContext$3 = _props$EditorContext$2.assetsFilters,
          assetsFilters = _props$EditorContext$3 === undefined ? [] : _props$EditorContext$3,
          appliedFilter = _props$EditorContext$2.appliedFilter;
      var deleteAsset = appliedFilter ? assetsFilters.reduce(function (result, assetFilter) {
        return assetFilter.filter === appliedFilter.filter ? assetFilter.deleteAsset : result;
      }, null) : null;

      if (!deleteAsset) {
        return null;
      }

      return function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(asset) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (confirm("Are you sure you want to delete this upload?")) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return");

                case 2:
                  _context.next = 4;
                  return deleteAsset(asset);

                case 4:
                  applyFilter(appliedFilter.filter, appliedFilter.value);

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    }
  }]);

  return Assets;
}(React.Component);

Assets.propTypes = process.env.NODE_ENV !== "production" ? {
  EditorContext: PropTypes.object.isRequired
} : {};
export default consumeContext(Assets);